import React, { useState } from "react";
import { EditableTextField } from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload } from "../../../../Global_Component/customFileUplodComponent";
import {
  Box,
  Grid,
  Typography
} from "@mui/material";
import { CustomSecondaryButton, CustomSuccessButton } from "../../../../Global_Component/GlobalButtonComponent";

const ProductInfoProfile = ({MoveToNextTab,MoveToPreviousTab}) => {
  const [uploadedFiles, setUploadedFiles] = useState({});

  const handleFileUpload = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
      
        borderRadius: "8px",
        backgroundColor: "#fff",
        height:"100%",
        overflowY:"auto"
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Company details
      </Typography>

      <Grid
        container
        sm={12}
        md={12}
        lg={8}
        xl={9}
        spacing={0}
      >
       

        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"No of Product to be Halal Certified"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={" Total No of Product in the P:lant"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Product Groups"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Brands of Products"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Product Varieties"} value={""} isEdit={true}/>
        </Grid>

    


       
      </Grid>

     <Grid xs={12} sx={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:1}}>
      <CustomSecondaryButton label={"Back"} sx={{margin:2}} onClick={e=>MoveToPreviousTab()}/>
        <CustomSuccessButton label={"Next"} onClick={e=>MoveToNextTab()}/>
     </Grid>
    </Box>
  );
};

export default ProductInfoProfile;
